
import { Swiper, Navigation, Pagination, Autoplay } from "swiper";
import { mapActions } from 'vuex';
import RecipeCard from './RecipeCard.vue';
export default {
    name: "recipe-container",
    components: { RecipeCard },
    data() {
        return {
            swiper: ''
        }
    },
    computed: {
        recipe_data() {
            return this.$store.state.recipe.recipe_data;
        }
    },
    methods: {
        ...mapActions("recipe", [
            "getRecipeData"
        ])
    },
    async fetch() {
        await this.$store.dispatch("recipe/getRecipeData");
    },
    mounted() {
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".recipe-swiper", {
            direction: "horizontal",
            slidesPerView: 'auto',
            slidesPerGroup: 3,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    }
}
